<template>
    <div style="background-color: #eeeeee;padding-bottom: 100px;">
        <img style="display: block;margin: 0 auto;" src="../../assets/img19.png" alt="">
        <div class="main">
            <ul class="Breadcrumb">
                <li @click="backPage('/home')">{{ $t("home") }}</li>
                <li>></li>
                <li>{{ $t("ContactUs") }}</li>
            </ul>
            <div>
                <h3 class="tab_title">{{ $t("ContactUs") }}</h3>
                <div class="contact">
                    <div>
                        <p>{{ $t("SalesInquiries") }}</p>
                        <span>sales@cimomicro.com<br />131 6184 0601</span>
                        <img src="../../assets/icon2.png" alt="">
                    </div>
                    <div>
                        <p>{{ $t("introduce1") }}</p>
                        <span>HR@cimomicro.com</span>
                        <img src="../../assets/icon3.png" alt="">
                    </div>
                    <div>
                        <p>{{ $t("introduce2") }}</p>
                        <span>info@cimomicro.com</span>
                        <img src="../../assets/icon4.png" alt="">
                    </div>
                    <!-- <div>
                        <p>{{ $t("ContactUs") }}</p>
                        <span>info@cimomicro.com</span>
                        <img src="../../assets/icon5.png" alt="">
                    </div> -->
                </div>
                <h3 class="tab_title">{{ $t("introduce3") }}</h3>
                <div class="address">
                    <div class="fleft">
                        <h3>{{ $t("introduce4") }}</h3>
                        <p>{{ $t("BeijingAddress") }}<br />
                            {{ $t("Email") }}：info@cimomicro.com<br />
                            {{ $t("phone") }}：010-62928103</p>
                    </div>
                    <div class="fleft" style="background-color: #eeeeee;">
                        <div style="height: 372px;" id="bai-du-map"><img style='width:100%' src="../../assets/beijing.png" alt=""></div>
                    </div>
                </div>
                <div class="address">
                    <div class="fleft">
                        <h3>{{ $t("introduce5") }}</h3>
                        <p>{{ $t("ChengduAddress") }}<br />
                            {{ $t("Email") }}：info@cimomicro.com<br />
                            {{ $t("phone") }}：028-62241216</p>
                    </div>
                    <div class="fleft" style="background-color: #eeeeee;">
                        <div style="height: 372px;" id="bai-du-map1"><img style='width:100%' src="../../assets/chengdu.png" alt=""></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import AMapLoader from "@amap/amap-jsapi-loader";
import {backPage} from '@/utils/common'

// 设置安全密钥
window._AMapSecurityConfig = {
    securityJsCode: '安全密钥',
}
export default {
    data() {
        return {
            map: null,
            mouseTool: null,
            overlays: [],
            auto: null,
            placeSearch: null,
   
        }
    },
    methods: {
        backPage,
        initMap() {

            // AMapLoader.load({
            //     "key": "ea9e66f53402e88ab4e9443f063a9474",
            //     "version": "2.0",   // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
            //     "plugins": ['AMap.Scale'],           // 需要使用的的插件列表，如比例尺'AMap.Scale'等
            // }).then((AMap) => {
            //     // 初始化地图
            //     this.map = new AMap.Map('bai-du-map', {
            //         viewMode: "2D",  //  是否为3D地图模式
            //         zoom: 16,   // 初始化地图级别
            //         center: [116.352747,40.014635], //中心点坐标  北京士模
            //         resizeEnable: true
            //     });
            //     let marker = new AMap.Marker({
            //         position: new AMap.LngLat(116.352747,40.014635),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
            //         title: '北京市海淀区学清路10号院学清嘉创大厦A座9层',
            //     });
            //     console.log(marker);
            //     this.map.add([marker])
            //     console.log(this.map);
            //     // this.setupMapTool()

            // }).catch(e => {
            //     console.log(e);
            // });
            // AMapLoader.load({
            //     "key": "ea9e66f53402e88ab4e9443f063a9474",
            //     "version": "2.0",   // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
            //     "plugins": ["AMap.Scale",],
            // }).then((AMap) => {
            //     // 初始化地图
            //     this.map = new AMap.Map('bai-du-map1', {
            //         viewMode: "2D",  //  是否为3D地图模式
            //         zoom: 16,   // 初始化地图级别
            //         center: [104.061216, 30.535496], //中心点坐标  成都士模
            //         resizeEnable: true,
            //         zoomEnable: true,
            //     });
            //     let marker = new AMap.Marker({
            //         position: new AMap.LngLat(104.061216, 30.535496),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
            //         title: '成都市高新区吉泰路10号汇顶科技大厦1栋1单元10层'
            //     });
            //     this.map.add([marker])
            //     this.setupMapTool()
            // }).catch(e => {
            //     console.log(e);
            // });
        },
        setupMapTool() {
            // 添加工具条控件，工具条控件集成了缩放、平移、定位等功能按钮在内的组合控件
            let controlBar = new AMap.ControlBar({
                position: {
                    top: '10px',
                    left: '10px',
                },
            });
            let toolBar = new AMap.ToolBar({
                position: {
                    top: '110px',
                    left: '35px'
                }
            });
            this.map.addControl(controlBar); // 方向盘
            this.map.addControl(toolBar);   // 添加右下角的放大缩小
            this.map.setDefaultCursor("pointer"); // 使用CSS默认样式定义地图上的鼠标样式
        }
    },
    mounted() {
        // this.initMap()
    }

}
</script>
<style lang="scss" scoped>
.title {
    border-left: 10px solid #d60e4c;
    line-height: 32px;
    text-indent: 30px;
    font-weight: bold;
    font-size: 36px;
    margin: 30px 0;
}

.contact {
    display: flex;
    margin-bottom: 20px;
    div {
        flex: 1;
        background-color: #fff;
        margin: 10px;
        border: 1px solid #c7c7c7;
        padding: 20px;

        >* {
            display: block;
            margin: 0 auto;
            color: #414141;
            text-align: center;
        }

        p {
            font-size: 22px;
            line-height: 64px;
        }

        span {
            font-size: 16px;
            line-height: 26px;
            height: 52px;
        }

        img {
            margin-top: 20px;
            height: 80px;
        }
    }
}

.address {
    overflow: hidden;
    border: 1px solid #c7c7c7;
    margin-top: 30px;

    >div {
        height: 372px;
        width: 50%;
        background-color: #fff;

        p {
            font-size:16px;
            line-height: 36px;
            padding-left: 54px;
        }

        h3 {
            font-size: 22px;
            line-height: 84px;
            text-indent: 54px;
            padding-top: 60px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/about/introduce.vue